import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { formatCurrency } from '../../lib/formatters';

const getStatusBadgeColor = (status) => {
  const colors = {
    'Funded': 'bg-green-100 text-green-800',
    'Payment Issues': 'bg-yellow-100 text-yellow-800',
    'In-House Collection': 'bg-orange-100 text-orange-800',
    'Default': 'bg-red-100 text-red-800',
    'Collected': 'bg-blue-100 text-blue-800',
    'Paid in Full': 'bg-purple-100 text-purple-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};

const PortfolioDealsTable = ({ filteredDeals }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Deals</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Deal
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Merchant
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Funded
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Collected
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Balance
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredDeals.slice(0, 10).map((deal) => (
                <tr key={deal.id} className={`hover:bg-gray-50 ${deal.status === 'Cancelled' ? 'line-through opacity-60' : ''}`}>
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-blue-600">
                    #{deal.deal_id}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                    {deal.deal_name}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                    {formatCurrency(deal.funding_amount)}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-green-600">
                    {formatCurrency(deal.payments_made)}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-orange-600">
                    {formatCurrency(deal.balance)}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusBadgeColor(deal.status)}`}>
                      {deal.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default PortfolioDealsTable;
